import { useCallback, useEffect, useState } from 'react';
import RModal from '../../../components/Rsuite/Modal';
import { Container, ContainerInterno } from '../styles';
import { FaStarOfLife } from 'react-icons/fa';
import api from '../../../services/api';
import { NotificationManager } from 'react-notifications';
import { CustomButton } from '../../../components/CustomButton';
import { CustomInput } from '../../../components/CustomInput';
import { CustomSelectPicker } from '../../../components/CustomSelectPicker';
import { useCustomTheme } from '../../../hooks/useCustomTheme';
import { schemaCreateUsuario, schemaEditUsuario } from '../schema/usuario.schema';
import { Toggle } from 'rsuite';

const EditarCadastrarUsuario = ({
  modal,
  close,
  usuario,
  setUsuarios,
  id_empresa,
}) => {
  const [nome, setNome] = useState('');
  const [login, setLogin] = useState('');
  const [senha, setSenha] = useState('');
  const [confirmacaoSenha, setConfirmacaoSenha] = useState('');
  const [ativo, setAtivo] = useState('');
  const [idGrupoAcesso, setIdGrupoAcesso] = useState(null);
  const [grupos, setGrupos] = useState([]);
  const [desabilitar, setDesabilitar] = useState(false);
  const { theme } = useCustomTheme();

  useEffect(() => {
    api.get(`grupo-acesso/listar/${id_empresa}`).then(({ data }) => {
      setGrupos(data.map((g) => ({ label: g.Nome, value: g.Id })));
    });
  }, [id_empresa]);

  const cadastrar = useCallback(async () => {
    setDesabilitar(true);
    schemaCreateUsuario.validate({
        IdEmpresa: id_empresa,
        Nome: nome,
        Login: login,
        Senha: senha,
        ConfirmacaoSenha: confirmacaoSenha
      }).then(async (validated) => {
          await api
            .post('gestor/criar', { ...validated, IdGrupoAcesso: idGrupoAcesso })
            .then((res) => {
              NotificationManager.success('Gestor cadastrado', 'Sucesso');
              setUsuarios((state) => [...state, res.data]);
              close();
            }).catch((error) => {
              NotificationManager.error('Erro ao cadastrar usuário: '+ error.response.data.message, 'Erro');
            })
      }).catch((error) => {
        NotificationManager.warning('Preencha os campos obrigatórios: '+ error.message, 'Aviso');
      }).finally(() => setDesabilitar(false))
  }, [close, confirmacaoSenha, id_empresa, idGrupoAcesso, login, nome, senha, setUsuarios]);

  const editar = useCallback(async () => {
      schemaEditUsuario.validate({
        Nome: nome,
        Login: login,
        Ativo: ativo,
      }).then(async (validated)=> {
        await api
          .patch(`gestor/alterar/${usuario?.Id}`, { ...validated, IdGrupoAcesso: idGrupoAcesso })
          .then((res) => {
            NotificationManager.success('Dados alterados', 'Sucesso');
            setUsuarios((state) =>
              state.map((e) => {
                if (e.Id !== res.data.Id) {
                  return e;
                }
                e = res.data;
                return e;
              }),
            );
            close();
          })
      }).catch((error) => {
        NotificationManager.warning('Preencha os campos obrigatórios: '+ error.message, 'Aviso');
      })

  }, [ativo, close, idGrupoAcesso, login, nome, setUsuarios, usuario]);

  useEffect(() => {
    if (usuario) {
      setNome(usuario.Nome);
      setLogin(usuario.Login);
      setAtivo(usuario.Ativo);
      setIdGrupoAcesso(usuario.IdGrupoAcesso || null);
    } else {
      setNome('');
      setLogin('');
      setAtivo(true);
      setIdGrupoAcesso(null);
    }
  }, [modal, usuario]);

  return (
    <RModal
      open={modal}
      onClose={close}
      title={usuario ? `Editar Usuário` : `Cadastrar Usuário`}
      footer={
        <>
          <CustomButton
            onClick={usuario ? editar : cadastrar}
            appearance="primary"
          >
            Salvar
          </CustomButton>
          <CustomButton onClick={close} appearance="ghost">
            Fechar
          </CustomButton>
        </>
      }
    >
      <form>
        <Container>
          <ContainerInterno>
            <label htmlFor="nome">
              <b style={{ color: theme.colors.textSecondary }}>
                Nome <FaStarOfLife size={8} color="#FF0000" />
              </b>
            </label>
            <CustomInput type="text" placeholder='Informe o Nome' value={nome} onChange={setNome} />
          </ContainerInterno>
          <ContainerInterno>
            <label htmlFor="login">
              <b style={{ color: theme.colors.textSecondary }}>
                E-mail (Login) <FaStarOfLife size={8} color="#FF0000" />
              </b>
            </label>
            <CustomInput type="text" placeholder='Informe o e-mail válido' value={login} onChange={setLogin} />
          </ContainerInterno>
        </Container>
        <ContainerInterno style={{ margin: '10px 0' }}>
          <label>
            <b style={{ color: theme.colors.textSecondary }}>Grupo de Acesso</b>
          </label>
          <CustomSelectPicker
            data={grupos}
            value={idGrupoAcesso}
            onChange={setIdGrupoAcesso}
            placeholder="Selecione um grupo (opcional)"
            style={{ width: '100%', marginTop: 4 }}
            cleanable
          />
        </ContainerInterno>
        {usuario && <ContainerInterno style={{ margin: 15 }}>
          <Toggle checkedChildren="Ativo" unCheckedChildren="Inativo" checked={ativo} onChange={()=> setAtivo(!ativo)} />
        </ContainerInterno>}
        {!usuario && <>
          <ContainerInterno style={{ marginTop: '10px',  }}>
            <label htmlFor="senha">
              <b style={{ color: theme.colors.textSecondary }}>
                Senha <FaStarOfLife size={8} color="#FF0000" />
              </b>
            </label>
            <CustomInput
              type="password"
              placeholder='Deverá conter no minimo 6 caracteres.'
              value={senha}
              onChange={setSenha}
              disabled={desabilitar}
            />
          </ContainerInterno>
          <ContainerInterno style={{ marginTop: '10px' }}>
            <label htmlFor="confirmacaoSenha">
              <b style={{ color: theme.colors.textSecondary }}>
                Confirmação de Senha <FaStarOfLife size={8} color="#FF0000" />
              </b>
            </label>
            <CustomInput
              type="password"
              placeholder='Deverá conter no minimo 6 caracteres.'
              value={confirmacaoSenha}
              onChange={setConfirmacaoSenha}
              disabled={desabilitar}
            />
          </ContainerInterno>
        </>}
      </form>
    </RModal>
  );
};

export default EditarCadastrarUsuario;
